import { ProjectDataService } from "../shared/services/project-data.service";
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjectRouteStationWithParam } from "../shared/interfaces/project-route-station.class";
import { ProjectGroup } from "../shared/interfaces/project-group.interface";
import { ImageDataService } from "../shared/services/image-data.service";
import { ProjectImageData } from "../shared/interfaces/project-image-data.interface";
import { Subscription } from "rxjs";
import { MetaInformationService } from "../shared/services/meta-information.service";
import { ProjectGroupMetaInformation } from "../shared/interfaces/project-group-meta-information";

@Component({
  selector: 'avs-project-station-overview',
  templateUrl: './project-station-overview.component.html',
  styleUrls: ['./project-station-overview.component.css']
})
export class ProjectStationOverviewComponent implements OnInit, OnDestroy {
  public projectRouteStations: ProjectRouteStationWithParam[] = [];
  public projectGroup: ProjectGroup | undefined;
  public projectImages: ProjectImageData[] = [];

  public subscriptionCollection: Subscription[] = [];
  public projectRouteStationsWithParamSubscription?: Subscription;
  public projectGroupSubscription?: Subscription;
  public projectImagesSubscription?: Subscription;

  public metaInformation: ProjectGroupMetaInformation[] = [];

  constructor(private readonly projectDataService: ProjectDataService,
    private readonly imageDataService: ImageDataService,
  private readonly metaInformationService: MetaInformationService) {
    this.projectRouteStationsWithParamSubscription = projectDataService.projectsRouteStationsWithParam.subscribe(routeStations => {
      this.projectRouteStations = [];
      if (routeStations) {
        this.projectRouteStations = this.sortRouteStations(routeStations);
      }
    });
    this.projectGroupSubscription = projectDataService.activeGroup.subscribe(activeGroup => {
      this.projectGroup = activeGroup;
      this.loadMetaInformation(activeGroup?.id);
    })
    this.projectImagesSubscription = imageDataService.projectImages.subscribe(images => {
      this.projectImages = images;
    });
  }

  public ngOnInit(): void {
    this.subscriptionCollection.push(this.projectRouteStationsWithParamSubscription!);
    this.subscriptionCollection.push(this.projectGroupSubscription!);
    this.subscriptionCollection.push(this.projectImagesSubscription!);
  }

  public ngOnDestroy(): void {
    this.subscriptionCollection.forEach(sub => sub.unsubscribe());
  }

  public reloadOverview(): void {
    this.projectDataService.updateActiveGroup(this.projectGroup!);
  }

  private loadMetaInformation(groupId: number | undefined): void {
    if (groupId === undefined) {
      this.metaInformation = [];
      return;
    }
    this.metaInformationService.getMetaInformationByGroupId(groupId)
      .subscribe(metaInformation => this.metaInformation = metaInformation ?? []);
  }

  public sortRouteStations(projectRouteStations: ProjectRouteStationWithParam[]): ProjectRouteStationWithParam[] {
    return projectRouteStations.sort((a, b) => {
      if (a.routeStation.samId < b.routeStation.samId) {
        return -1;
      } else if (a.routeStation.samId > b.routeStation.samId) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}
